// src/components/library/BookCover.js
import React from 'react';
import { Link } from 'react-router-dom';

const BookCover = ({ book, linkTo }) => {
    const { slug, title, cover_image_url } = book;
    const finalLink = linkTo || `/books/${slug}`;

    return (
        <Link to={finalLink} className="block group">
            <div className="w-full bg-gray-100 rounded-lg overflow-hidden  transition-shadow group-hover:shadow-md">
                {/* کادر جلد با نسبت 3:4 */}
                <div className="relative pt-[133.33%]">
                    <img
                        src={cover_image_url}
                        alt={title}
                        className="absolute inset-0 w-full h-full object-cover"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `https://placehold.co/300x400/e2e8f0/94a3b8?text=${encodeURIComponent(title)}`;
                        }}
                    />
                    {/* گرادیانت سفید از پایین به بالا (روی تصویر) */}
                </div>
            </div>
            {/* عنوان کتاب با فونت نازک */}
            <h3 className="mt-2 text-center text-[11px] font-reqular text-gray-700 line-clamp-2 group-hover:text-indigo-600 transition">
                {title}
            </h3>
        </Link>
    );
};

export default BookCover;